/**Import react section */
import React, { useState } from 'react'
/**Import common componets */
import TextBox from '../../common/TextBox'
import ButtonConfirm from '../../common/Buttons/ButtonConfirm'
/**Import MaterialUi section */
import { Grid } from '@material-ui/core'
import {createServicesStyle} from '../../../resources/styles/CreateServiceStyles'

const ChangeStatusMessage = (props) => {
    const { onSetPasswordDialogConfiguration, IsClosed, status } = props;
    const classes = createServicesStyle();
    const [requestModel, setRequestModel] = useState({comments:'', status: props.status});

    const openModalForChangeRequest = () => {
        if (onSetPasswordDialogConfiguration)
            onSetPasswordDialogConfiguration(requestModel, status)
    }

    /**On change properties */
    const onPropertyChange = event => {
        let { name, value } = event.target;
        setRequestModel({
            ...requestModel,
            [name]: value
        });

    }

    /**Verify if can be sabed */
    const canBeSaved = () => {
        if (requestModel ? (requestModel.comments.length <= 0) : true) return false;
        return true;
    }

    return (
        <div>
            <Grid item xs={12}>
                <TextBox
                    active={true}
                    fullWidth
                    autoFocus
                    disabled={IsClosed}
                    name="comments"
                    variant="outlined"
                    margin="dense"
                    label="REASON FOR REJECTED"
                    multiline
                    rows={4}
                    onChange={onPropertyChange}
                    value={requestModel ? requestModel.comments : ""}
                />
            </Grid>
            {
                !IsClosed && <Grid item xs={12} className={classes.updateButton}>
                    <ButtonConfirm
                        title="CONFIRM"
                        isSaving={!canBeSaved()}
                        onSavedClick={openModalForChangeRequest}
                    />
                </Grid>
            }
        </div>
    )
}

export default ChangeStatusMessage
